module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hide) ? _c('div', [_c('div', {
    staticClass: "update"
  }, [_c('div', {
    staticClass: "form-update"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Memo",
      "name": "memo"
    }
  }, [_c('el-form', {
    ref: "formMemo",
    staticClass: "formMemo",
    attrs: {
      "label-position": "top",
      "model": _vm.formMemo,
      "rules": _vm.rulesMemo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Memo",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      }
    },
    model: {
      value: (_vm.formMemo.memo),
      callback: function($$v) {
        _vm.$set(_vm.formMemo, "memo", $$v)
      },
      expression: "formMemo.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loadingMemo,
      "type": "primary",
      "disabled": _vm.memoDisable
    },
    on: {
      "click": function($event) {
        _vm.update('formMemo')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('vue-twitter-counter', {
    staticClass: "counter",
    attrs: {
      "underlay": "#67C23A",
      "current-length": _vm.formMemo.memo.length,
      "dangerAt": 1004
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Review",
      "name": "review"
    }
  }, [_c('el-form', {
    ref: "formReview",
    staticClass: "formReview",
    attrs: {
      "label-position": "top",
      "model": _vm.formReview,
      "rules": _vm.rulesReview
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Review",
      "prop": "rate"
    }
  }, [_c('el-rate', {
    attrs: {
      "texts": ['oops', 'disappointed', 'normal', 'good', 'great'],
      "show-text": ""
    },
    model: {
      value: (_vm.formReview.rate),
      callback: function($$v) {
        _vm.$set(_vm.formReview, "rate", $$v)
      },
      expression: "formReview.rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "your experience"
    }
  }, [_c('el-input', {
    attrs: {
      "autosize": {
        minRows: 5
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.formReview.review),
      callback: function($$v) {
        _vm.$set(_vm.formReview, "review", $$v)
      },
      expression: "formReview.review"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "loading": _vm.loadingReview,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.update('formReview')
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('vue-twitter-counter', {
    staticClass: "counter",
    attrs: {
      "underlay": "#67C23A",
      "current-length": JSON.stringify(_vm.formReview).length,
      "dangerAt": 1004
    }
  })], 1)], 1)], 1)], 1)], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f151ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateProduct.vue
// module id = 1142
// module chunks = 20